import classnames from 'classnames';
import { useEffect, useState } from 'react';
import { Json } from 'shared-base/dist/types';
import { Option, Options, Text, Wrapper } from './Picker.style';
import { normalizeName } from './Picker.utils';

export type PickerProps = {
  param: Json;
  onChange: (value: string) => void;
  onSet: (value: string) => void;
};

export function Picker(props: PickerProps) {
  const { param } = props;
  const { options = [], value } = param ?? {};
  const [val, setVal] = useState(value);

  useEffect(() => {
    setVal(value);
  }, [value]);

  function onChange(value: string) {
    props.onChange(value);
    props.onSet(value);
    setVal(value);
  }

  function renderOption(option: string, index: number) {
    const selected = option === val;

    const className = classnames('option', {
      selected,
    });

    return (
      <Option key={option + index} className={className} onMouseDown={() => onChange(option)}>
        <Text>{normalizeName(option)}</Text>
      </Option>
    );
  }

  function renderOptions() {
    return options.map((option: string, index: number) => renderOption(option, index));
  }

  return (
    <Wrapper className='Picker-wrapper' data-testid='Picker-wrapper'>
      <Options>{renderOptions()}</Options>
    </Wrapper>
  );
}

export default Picker;
